import { render, staticRenderFns } from "./MultiselectOption.vue?vue&type=template&id=080b79a8"
import script from "./MultiselectOption.vue?vue&type=script&lang=js"
export * from "./MultiselectOption.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./MultiselectOption.vue?vue&type=style&index=1&id=080b79a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports